import { resetState } from '@/shared/action/resetState'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const logoutUser = createAsyncThunk('auth/logoutUser', async (_, { dispatch }) => {
  dispatch(resetState())
})